import {
  AI_INTENTS,
  AI_UI_STATES,
  AI_URGENCIES,
  assertKnownIntent,
} from '../../constants/aiSearchIntents';

export function deriveUIState(intent, urgency) {
  assertKnownIntent(intent);

  if (
    intent === AI_INTENTS.MEDICAL_EMERGENCY ||
    urgency === AI_URGENCIES.HIGH
  ) {
    return AI_UI_STATES.EMERGENCY;
  }

  if (intent === AI_INTENTS.COMMUNITY_QUESTION) {
    return AI_UI_STATES.INFO;
  }

  return AI_UI_STATES.NORMAL;
}
